(() => {
  const scrollLockClass = 'klaviyo-prevent-body-scrolling';

  const unlockPage = () => {
    document.body.classList.remove(scrollLockClass);
  };

  const dismissSignupUi = () => {
    document
      .querySelectorAll(
        '[role="dialog"][aria-label*="POPUP Form"] button[aria-label="Close dialog"], button[aria-label="Close teaser"]'
      )
      .forEach((button) => button.click());

    unlockPage();
  };

  dismissSignupUi();

  new MutationObserver(dismissSignupUi).observe(document.body, {
    childList: true,
    subtree: true,
  });

  new MutationObserver(() => {
    if (document.body.classList.contains(scrollLockClass)) {
      unlockPage();
    }
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
